import React, { forwardRef, useState } from "react";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import Dialog from "@mui/material/Dialog";
import DownloadButton from "../../../Common/Button/DownloadButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { Box, Button } from "@mui/material";

import { toBase64 } from "../../../../utilities/base64";

const pdfToolsURL = 'https://pdf-tools.premierit.co.uk/pdf/viewer/v2';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

export default function ModuleMediaDocumentViewer({media, moduleId, onComplete}) {
    const [open, setOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const title = media.name ? media.name : "Untitled";
    const url = media.url ? media.url : "";

    const isPdf = url.match("\\w+\\.pdf$", "i");
    const isWord = url.match("\\w+\\.docx?$", "i");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        onComplete();
        setConfirmDialogOpen(false);
        setOpen(false);
    };

    return (
        <div>
            <Button
                id={`view_mod_${moduleId}`}
                variant="contained"
                onClick={handleClickOpen}
                aria-labelledby={`view_mod_${moduleId} mod_${moduleId}_title`}
                className="btn-medium"
                disableElevation={true}
            >
                View
            </Button>

            <Dialog
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: "fixed" }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography
                            sx={{ ml: 2, flex: 1 }}
                            variant="h6"
                            component="h2"
                        >
                            {title}
                        </Typography>
                        {!!media?.download && (
                            <DownloadButton
                                url={media.download}
                                filename={media.filename}
                                variant=""
                            />
                        )}
                        <Button
                            autoFocus
                            variant=""
                            color="primary"
                            onClick={() => setConfirmDialogOpen(true)}
                        >
                            Confirm
                        </Button>
                    </Toolbar>
                </AppBar>

                <div className="media-placeholder media-placeholder-document">
                    {isPdf && (
                        <iframe
                            width="100%"
                            height="100%"
                            style={{ border: "none", padding: "0" }}
                            title={title}
                            src={`${pdfToolsURL}?src=${toBase64(url)}`}
                        />
                    )}
                    {isWord && <Box>This is a word document</Box>}
                </div>
            </Dialog>
            <ConfirmDialog
                open={!!confirmDialogOpen}
                title="Confirm"
                content="Please confirm that you have reviewed the associated material"
                confirmButtonLabel="Confirm"
                onConfirm={handleConfirm}
                onCancel={() => setConfirmDialogOpen(false)}
                onClose={() => setConfirmDialogOpen(false)}
            />
        </div>
    );
}
